<template>
  <div class="border-left pl-2">
    <CRow>
      <CCol sm="12">
        <CInput
          :label="label_overrides && label_overrides.street_address ? label_overrides.street_address : 'Street Address'"
          placeholder=""
          v-model="form.street_address"
          :horizontal="true"
          :addLabelClasses="['font-weight-bold']"
          required
        />
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="12">
        <CInput
          :label="label_overrides && label_overrides.billing_address ? label_overrides.billing_address : 'Billing Address'"
          placeholder=""
          v-model="form.billing_address"
          :horizontal="true"
          :addLabelClasses="['font-weight-bold']"
          required
        />
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="12">
        <CInput
          :label="label_overrides && label_overrides.city ? label_overrides.city : 'City'"
          placeholder=""
          v-model="form.city"
          :horizontal="true"
          :addLabelClasses="['font-weight-bold']"
          required
        />
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="12">
        <CInput
          :label="label_overrides && label_overrides.region ? label_overrides.region : 'Province/State'"
          placeholder=""
          v-model="form.region"
          :horizontal="true"
          :addLabelClasses="['font-weight-bold']"
          required
        />
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="12">
        <CInput
          :label="label_overrides && label_overrides.country ? label_overrides.country : 'Country'"
          placeholder=""
          v-model="form.country"
          :horizontal="true"
          :addLabelClasses="['font-weight-bold']"
          required
        />
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="12">
        <CInput
          :label="label_overrides && label_overrides.postal ? label_overrides.postal : 'Postal/Zip'"
          placeholder=""
          v-model="form.postal"
          :horizontal="true"
          :addLabelClasses="['font-weight-bold']"
          required
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
  export default {
  name: 'CustomerLocationForm',
  data() {
    return {
      form: {
        street_address: null,
        billing_address: null,
        city: null,
        region: null,
        country: null,
        postal: null
      }
    };
  },
  props: {
    shipping_address: {
      type: Object,
      default: null
    },
    billing_address: {
      type: Object,
      default: null
    },
    label_overrides: {
      type: Object,
      default: null
    }
  },
  methods: {
    populate() {
      for(let k in this.form) {
        if(k === 'billing_address' && this.billing_address && this.billing_address['street_address']) {
          this.form[k] = this.billing_address['street_address'];
        } else {
          if(this.billing_address && this.billing_address[k]) {
            this.form[k] = this.billing_address[k];
          }
          if(this.shipping_address && this.shipping_address[k]) {
            this.form[k] = this.shipping_address[k];
          }
        }
      }
    }
  },
  watch: {
    form: {
      handler: function() {
        this.$emit('change', {...this.form});
      },
      deep: true
    }
  },
  mounted() {
    this.populate();
  }
}
</script>
